module.exports = __webpack_public_path__ + "img/menu-logo.728433e1.png";